export const HYP_SET_ORG_PREFERENCES = 'HYP_SET_ORG_PREFERENCES';
